var _g, _rect, _rect2, _g2, _g3, _rect3, _rect4, _g4, _g5, _rect5, _rect6, _g6, _g7, _rect7, _rect8, _g8, _circle, _circle2, _circle3, _circle4, _g9, _circle5, _circle6, _g10, _g11, _circle7, _circle8, _g12, _g13, _circle9, _circle10, _g14, _g15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoleculeModel4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 165,
    viewBox: "0 0 159 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_681_4173)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.0586,
    height: 1.3101,
    transform: "matrix(-0.397045 0.917799 0.917799 0.397045 152.195 92.0735)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.0586,
    height: 1.3101,
    transform: "matrix(-0.397045 0.917799 0.917799 0.397045 152.195 92.0735)",
    fill: "url(#paint0_radial_681_4173)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60.7514,
    height: 3.9303,
    rx: 1.96515,
    transform: "matrix(-0.397045 0.917799 0.917799 0.397045 154.703 82.9764)",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 60.7514,
    height: 3.9303,
    rx: 1.96515,
    transform: "matrix(-0.397045 0.917799 0.917799 0.397045 154.703 82.9764)",
    fill: "url(#paint1_radial_681_4173)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_681_4173)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.7514,
    height: 3.9303,
    transform: "matrix(-0.397045 0.917799 0.917799 0.397045 154.703 82.9764)",
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_681_4173)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.523,
    height: 1.3101,
    transform: "matrix(1 0 0 -1 65.8281 146.57)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.523,
    height: 1.3101,
    transform: "matrix(1 0 0 -1 65.8281 146.57)",
    fill: "url(#paint2_radial_681_4173)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 71.5333,
    height: 3.9303,
    rx: 1.96515,
    transform: "matrix(1 0 0 -1 54.8281 147.881)",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 71.5333,
    height: 3.9303,
    rx: 1.96515,
    transform: "matrix(1 0 0 -1 54.8281 147.881)",
    fill: "url(#paint3_radial_681_4173)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_681_4173)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.5333,
    height: 3.9303,
    transform: "matrix(1 0 0 -1 54.8281 147.881)",
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_681_4173)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.4535,
    height: 1.3101,
    transform: "matrix(-0.421834 -0.906673 -0.906673 0.421834 43.0547 128.781)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.4535,
    height: 1.3101,
    transform: "matrix(-0.421834 -0.906673 -0.906673 0.421834 43.0547 128.781)",
    fill: "url(#paint4_radial_681_4173)"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 59.8773,
    height: 3.9303,
    rx: 1.96515,
    transform: "matrix(-0.421834 -0.906673 -0.906673 0.421834 48.125 136.58)",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 59.8773,
    height: 3.9303,
    rx: 1.96515,
    transform: "matrix(-0.421834 -0.906673 -0.906673 0.421834 48.125 136.58)",
    fill: "url(#paint5_radial_681_4173)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_b_681_4173)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.8773,
    height: 3.9303,
    transform: "matrix(-0.421834 -0.906673 -0.906673 0.421834 48.125 136.58)",
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_681_4173)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.5527,
    height: 1.3101,
    transform: "matrix(0.529586 -0.848256 -0.848256 -0.529586 27.6016 67.194)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.5527,
    height: 1.3101,
    transform: "matrix(0.529586 -0.848256 -0.848256 -0.529586 27.6016 67.194)",
    fill: "url(#paint6_radial_681_4173)"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 57.1317,
    height: 3.9303,
    rx: 1.96515,
    transform: "matrix(0.529586 -0.848256 -0.848256 -0.529586 24.0547 75.3442)",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 57.1317,
    height: 3.9303,
    rx: 1.96515,
    transform: "matrix(0.529586 -0.848256 -0.848256 -0.529586 24.0547 75.3442)",
    fill: "url(#paint7_radial_681_4173)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_b_681_4173)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.1317,
    height: 3.9303,
    transform: "matrix(0.529586 -0.848256 -0.848256 -0.529586 24.0547 75.3442)",
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.6673,
    cy: 20.0345,
    r: 20.0345,
    fill: "#AABFA7",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.6673,
    cy: 20.0345,
    r: 20.0345,
    fill: "url(#paint8_radial_681_4173)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.1648,
    cy: 19.5336,
    r: 9.51638,
    fill: "#B2B2B2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.1648,
    cy: 19.5336,
    r: 9.51638,
    fill: "url(#paint9_radial_681_4173)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_b_681_4173)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57.6673,
    cy: 20.0345,
    r: 20.0345,
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.8157,
    cy: 144.247,
    r: 20.0345,
    fill: "#AABFA7",
    fillOpacity: 0.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.8157,
    cy: 144.247,
    r: 20.0345,
    fill: "url(#paint10_radial_681_4173)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_681_4173)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49.1508,
    cy: 144.821,
    r: 9.15862,
    fill: "#45756E",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.1508,
    cy: 144.821,
    r: 9.15862,
    fill: "url(#paint11_radial_681_4173)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_b_681_4173)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48.8157,
    cy: 144.247,
    r: 20.0345,
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.363,
    cy: 144.247,
    r: 20.0345,
    fill: "#FFBE7F",
    fillOpacity: 0.2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.363,
    cy: 144.247,
    r: 20.0345,
    fill: "url(#paint12_radial_681_4173)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_681_4173)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.563,
    cy: 143.246,
    rx: 8.41448,
    ry: 8.21414,
    fill: "#FFBE7F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.563,
    cy: 143.246,
    rx: 8.41448,
    ry: 8.21414,
    fill: "url(#paint13_radial_681_4173)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_b_681_4173)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 130.363,
    cy: 144.247,
    r: 20.0345,
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.6515,
    cy: 79.509,
    r: 19.6515,
    fill: "#AABFA7"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.6515,
    cy: 79.509,
    r: 19.6515,
    fill: "url(#paint14_radial_681_4173)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_681_4173)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.3263,
    cy: 79.8359,
    r: 9.49822,
    fill: "#FFBE7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.3263,
    cy: 79.8359,
    r: 9.49822,
    fill: "url(#paint15_radial_681_4173)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_b_681_4173)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.6515,
    cy: 79.509,
    r: 19.6515,
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_681_4173",
    x: 131.5,
    y: 88.0735,
    width: 25.8984,
    height: 47.1215,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_681_4173"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_681_4173",
    x: 125.586,
    y: 77.9764,
    width: 37.7266,
    height: 67.3181,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_681_4173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_681_4173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_681_4173",
    x: 61.8281,
    y: 141.26,
    width: 57.5234,
    height: 9.31012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_681_4173"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_681_4173",
    x: 49.8281,
    y: 138.95,
    width: 81.5312,
    height: 13.9303,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_681_4173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_681_4173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_681_4173",
    x: 20.3828,
    y: 87.1962,
    width: 26.6719,
    height: 46.1375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_681_4173"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_681_4173",
    x: 14.3047,
    y: 77.291,
    width: 38.8203,
    height: 65.9471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_681_4173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_681_4173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_681_4173",
    x: 22.4922,
    y: 28.9493,
    width: 30.0547,
    height: 42.2447,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_681_4173"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_b_681_4173",
    x: 15.7188,
    y: 19.8005,
    width: 43.5938,
    height: 60.5438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_681_4173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_681_4173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_b_681_4173",
    x: 32.6328,
    y: -5,
    width: 50.0703,
    height: 50.069,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_681_4173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_681_4173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_681_4173",
    x: 29.9922,
    y: 125.662,
    width: 38.3203,
    height: 38.3173,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_681_4173"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_b_681_4173",
    x: 23.7812,
    y: 119.213,
    width: 50.0703,
    height: 50.069,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_681_4173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_681_4173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_681_4173",
    x: 111.148,
    y: 125.032,
    width: 36.8281,
    height: 36.4283,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_681_4173"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_b_681_4173",
    x: 105.328,
    y: 119.213,
    width: 50.0703,
    height: 50.069,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_681_4173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_681_4173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_681_4173",
    x: 0.828125,
    y: 60.3376,
    width: 39,
    height: 38.9965,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_681_4173"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_b_681_4173",
    x: -4,
    y: 54.8575,
    width: 49.3047,
    height: 49.303,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_681_4173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_681_4173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_681_4173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.49121 -0.22531) rotate(3.23863) scale(27.8369 1.75098)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_681_4173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.1766 1.18082) rotate(3.59563) scale(34.421 4.4431)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_681_4173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.2883 -0.22531) rotate(2.7513) scale(32.7628 1.75176)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_681_4173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.225 1.18082) rotate(3.05479) scale(40.5077 4.44554)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_681_4173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.4266 -0.22531) rotate(3.28581) scale(27.4377 1.7509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_681_4173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.9295 1.18082) rotate(3.64797) scale(33.9277 4.44285)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_681_4173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.22362 -0.22531) rotate(3.44334) scale(26.1839 1.75062)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_681_4173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1532 1.18082) rotate(3.82278) scale(32.3785 4.44196)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_681_4173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.9618 12.0383) rotate(44.1659) scale(31.5866 32.5567)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_681_4173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.6808 6.74397) rotate(61.1678) scale(26.0799 12.2869)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_681_4173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.1102 136.251) rotate(44.1659) scale(31.5866 32.5567)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_681_4173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.9482 132.512) rotate(61.1678) scale(25.0994 11.825)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_681_4173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.657 136.251) rotate(44.1659) scale(31.5866 32.5567)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_681_4173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.946 132.206) rotate(60.5808) scale(22.6399 10.8024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_681_4173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.1124 71.6658) rotate(44.1659) scale(30.9828 31.9344)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_681_4173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.8567 67.0707) rotate(61.1678) scale(26.0301 12.2635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoleculeModel4);
export default __webpack_public_path__ + "static/media/molecule-model-4.2e53f43b962f40b1250b481d3239274b.svg";
export { ForwardRef as ReactComponent };